<div class="otp-input">
  <input type="text" maxlength="1" placeholder="x" #otpInput (keyup)="moveFocus(otpInput, 0)" (paste)="handlePaste($event)" />
  <input type="text" maxlength="1" placeholder="x" #otpInput (keyup)="moveFocus(otpInput, 1)" (paste)="handlePaste($event)" />
  <input type="text" maxlength="1" placeholder="x" #otpInput (keyup)="moveFocus(otpInput, 2)" (paste)="handlePaste($event)" />
  <input type="text" maxlength="1" placeholder="x" #otpInput (keyup)="moveFocus(otpInput, 3)" (paste)="handlePaste($event)" />
  <input type="text" maxlength="1" placeholder="x" #otpInput (keyup)="moveFocus(otpInput, 4)" (paste)="handlePaste($event)" />
  <input type="text" maxlength="1" placeholder="x" #otpInput (keyup)="moveFocus(otpInput, 5)" (paste)="handlePaste($event)" />
</div>
